import React from 'react'
import Tr from 'translations/Translations';
import LaunchIcon from '@material-ui/icons/Launch';
import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from 'clsx';
import WorkableIconButton from "./WorkableIconButton";
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    rotate: {
        transform: "rotate(90deg)"
    }
}));

function WorkableIconUnpublishButton(
    {
        tooltip = Tr('unpublish'),
        className,
        ...props
    }) {
    const classes = useStyle();
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={LaunchIcon}
        className={clsx(className, classes.rotate)}
        {...props}
    />

}

WorkableIconUnpublishButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconUnpublishButton;